import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { AxiosResponse } from 'axios';

import { serverAxios } from '../../http';
import { IPaymentResponse } from 'pages/Jobs/JobForm/JobFormUpdate/JobPayments/JobPayments.model';
import { IGetTransactionsResponse } from 'models/http/payment';

class PaymentsHttp {
  private static route = '/';

  public async getTrans<Count extends boolean = false>(
    filters: Record<string, unknown>,
    queryData: Record<string, unknown>,
    count?: Count,
    abortController?: AbortController
  ): Promise<AxiosResponse<IGetTransactionsResponse<true>>> {
    return serverAxios
      .post(
        PaymentsHttp.route,
        {
          act: 'find',
          col: 'trans',
          count,
          ...queryData,
          query: filters,
        },
        {
          signal: abortController?.signal,
          timeout: HttpTimeoutPriority.Medium,
        },
      )
      .then((response: AxiosResponse<IGetTransactionsResponse<true>>) => {
        return response;
      });
  }

  public async paymentButton(jobId: string, act: string): Promise<AxiosResponse<IPaymentResponse>> {
    return serverAxios
      .post(
        PaymentsHttp.route,
        {
          act,
          jobId,
        },
        {
          timeout: HttpTimeoutPriority.Highest,
        },
      )
      .then((response: AxiosResponse<IPaymentResponse>) => {
        return response;
      });
  }

  public async cardknoxPayment(jobId: string, price: number, xName: string, xExp: string, xCardNum?: string): Promise<void> {
    return serverAxios
      .post(PaymentsHttp.route, {
        act: 'cardknoxpayment',
        jobId,
        price,
        xName,
        xCardNum,
        xExp,
      })
      .then(() => {
        return;
      });
  }

  public async stripePayment(jobId: string, price: number, payer: string, stripeToken?: string): Promise<void> {
    return serverAxios
      .post(PaymentsHttp.route, {
        act: 'stripepayment',
        jobId,
        price,
        stripeToken,
        payer,
      })
      .then(() => {
        return;
      });
  }
}

export default PaymentsHttp;